import { SecurityGroup } from '../../roles/models/security-group.model';

export enum FilterUser {
  ClearFilter = 0,
}

export enum NumberMonthAgo {
  Last1Month = 1,
  Last6Month = 6,
}

export enum SortParam {
  FirstName_ASC = 'FirstName_ASC',
  FirstName_DESC = 'FirstName_DESC',
  LastAccessedDate_ASC = 'LastAccessedDate_ASC',
  LastAccessedDate_DESC = 'LastAccessedDate_DESC',
}

export class FilterDateAccessed {
  specificDate!: Date;
  fromDate!: Date;
  toDate!: Date;
  isOptionFilterPeriod: boolean = false;
  isReload: boolean = true;
}

export enum DefaultDate {
  MinDate = '0001-01-01',
}

export class AddEditEmployeeRequest {
  employee: EmployeeModel = new EmployeeModel();
  positions: Position[] = [];
  permissions: SecurityGroup[] = [];
  departmentIds: number[] = [];
  oldDepartmentName?: string;
}

export class Position {
  id: any;
  name!: string;
  weight!: number;
  sort!: number;
}

export class EmployeeResponseModel {
  employees: EmployeeModel[] = [];
  total!: number;
}

export class EmployeeModel {
  id!: number;
  employeeNo = '';
  departmentId: any;
  departmentName!: string;
  firstName = '';
  lastName = '';
  title = '';
  address = '';
  countryId!: number;
  countryName!: string;
  phoneHome = '';
  phoneInternal = '';
  phoneWork = '';
  phoneMobile = '';
  beeper = '';
  callNumber = '';
  fax = '';
  email = '';
  loginName = '';
  loginDomain = '';
  password = '';
  repeatPassword = '';
  comment = '';
  lastLogin?: Date;
  zipCode = '';
  hasEditPassword: boolean = false;
  fullNameAndDepartmentName!: string;
  loginAttemptFailed!: number;
  hashAlgorithm!: string;
  fullName!: string;
  place!: string;
  idNumber!: string;
}

export class AddMemberToRoleRequest {
  roleId: number | undefined;
  employeeIds: number[] | undefined;
  employeeNames: string[] | undefined;
}
